import React from 'react'
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";


import Typography from "@mui/material/Typography";
import { Box, Grid } from '@mui/material';
import { LoadingScreen } from '../pages/Notification';


export default function NotificationCard({notification,open}) {
 const renderNotification = notification.map((elm)=>{
  return(
 <Grid key={elm?.title} item md={4} sm={6} xs={12} lg={3} style={{paddingTop:"0px", paddingLeft:"0px"}}>
<Card sx={{ maxWidth: 345 , margin:'20px'}}>
      <CardHeader
      
        title={elm?.title.toUpperCase()}
        subheader={elm?.date + "\n" + elm?.time}
         
      />
      <CardMedia
        component="img"
        height="50"
        image={elm?.img}
        alt="Paella dish"
        style={{height:"200px", width:"100%"}}
      />
      <CardContent>
        {elm?.senderName}
        <Typography variant="body2" color="text.secondary" sx={{maxHeight:"40px"}}>
         {elm?.notification
}
        </Typography>
      </CardContent>
    </Card>
 </Grid>
  )
 })
  return (
    <Box sx={{marginTop:{xs:"70px",  lg:"100px"}}} >
      <LoadingScreen open={open} />
      <Grid container>
      {renderNotification}
      </Grid>  
     
    </Box>
  )
}
